export default __webpack_public_path__ + "static/assets/med_x_spray_oral.0c5fb189.png";